export enum COUNTER_OPERATION {
    ADD,
    SUBTRACT,
    RECALCULATE
}